import {
  AssessmentMatch,
  AssessmentQuestionnaireCategory,
} from "../model/assessment";
import { RATING_TYPE } from "./enums";
export const isValidEmail = (email: string): boolean => {
  if (!email || !email?.trim().length) {
    return false;
  }

  const regExp =
    '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';

  const matcher = new RegExp(regExp);
  const keywordTest = email.trim();

  return matcher.test(keywordTest);
};

export const isValidAssessmentMatchRating = (
  value: string | number,
  type: string
): boolean => {
  if (type === RATING_TYPE.free) {
    return value ? true : false;
  } else if (type === RATING_TYPE.one_to_five) {
    return typeof value === "number" && value > -1 && value <= 5;
  } else if (type === RATING_TYPE.one_to_ten) {
    return typeof value === "number" && value > -1 && value <= 10;
  } else return false;
};

export const isValidAssessmentMatch = (
  assessmentMatch: AssessmentMatch
): boolean => {
  return !assessmentMatch.assessment.categories.some((category) =>
    category.questions.some((question) => {
      const evaluation = question.assessment_evaluations[0];
      if (!evaluation) return true;
      switch (question.ratingType) {
        case RATING_TYPE.free:
          return !evaluation.ratingText;
        case RATING_TYPE.one_to_five:
          return !(evaluation.ratingValue || evaluation.notApplicable);
        default:
          return true;
      }
    })
  );
};

export const isValidAssessmentGroup = (
  categories: AssessmentQuestionnaireCategory[]
): boolean => {
  return !categories.some((category) =>
    category.questions.some((question) => {
      return question.matches.some((match) => {
        const evaluation = match.evaluation;
        if (!evaluation) return true;
        switch (question.ratingType) {
          case RATING_TYPE.free:
            return !evaluation.ratingText;
          case RATING_TYPE.one_to_five:
            return !(evaluation.ratingValue || evaluation.notApplicable);
          default:
            return true;
        }
      });
    })
  );
};
